const DefaultLanguagefromlURL = () => {
  const url = window.location.href
  if (url.includes('annatel.net')){
    return "fr_FR"
  }

  if (url.includes('annatel.us') || url.includes('en_US')  ){
    return "en_US"
  }

  return "fr_FR"
}
export default DefaultLanguagefromlURL;



// WEBPACK FOOTER //
// ./src/localeAssets/DefaultLanguageFronUrl.js